module.exports = __webpack_public_path__ + "img/single-post-img3.80e82235.jpg";